import { ChangeDetectionStrategy, Component, signal, viewChild } from '@angular/core';
import { NovaButton } from '@rds-nova/angular-button';
import { TranslatePipe } from '@ngx-translate/core';

import { SimpleDialogComponent } from 'src/app/shared/components/simple-dialog/simple-dialog.component';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';

@Component({
  selector: 'app-legal-acknowledgement-dialog',
  template: `
    <app-simple-dialog
      [title]="dialogTitle()"
      [analyticsPrefix]="'legal-acknowledgement-dialog'"
      [hasActions]="true"
    >
      <div dialog-content class="legal-acknowledgement-dialog__content" [innerHTML]="htmlContent()"></div>
      <div dialog-actions>
        <button
          novaButton
          appTrackedButton
          [trackId]="'legal-acknowledgement-dialog:close'"
          [trackType]="'close'"
          [variant]="'secondary'"
          (click)="close()"
        >
          {{ 'dialog.close' | translate }}
        </button>
      </div>
    </app-simple-dialog>
  `,
  styles: `
    :host ::ng-deep .nova-dialog {
      width: 90vw;
      max-width: 720px;
    }

    .legal-acknowledgement-dialog__content {
      max-height: 60vh;
      overflow-y: auto;
      overflow-wrap: anywhere;
    }
  `,
  imports: [SimpleDialogComponent, NovaButton, TranslatePipe, TrackedButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalAcknowledgementDialogComponent {
  private readonly dialog = viewChild.required(SimpleDialogComponent);

  dialogTitle = signal('');
  htmlContent = signal('');

  open(title: string, content: string): void {
    this.dialogTitle.set(title);
    this.htmlContent.set(content);
    this.dialog().open();
  }

  close(): void {
    this.dialog().close();
  }
}
